module.exports = __webpack_public_path__ + "img/symbol_9.1317b695.png";